import { Injectable } from '@angular/core';
import { PublisherTag } from 'app/modules/main/models/publisher-tags-and-promotional-types';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';

@Injectable({ providedIn: 'root' })
export class PublisherTagSelectorMapper {

  public toPublisherTags(
    selectablePublisherTags: SelectableData<PublisherTag>[]
  ): PublisherTag[] {

    return selectablePublisherTags
      .map(selectablePublisherTag => selectablePublisherTag.data);
  }

  public toSelectablePublisherTags(
    publisherTags: PublisherTag[],
    selectedPublisherTags: PublisherTag[]
  ): SelectableData<PublisherTag>[] {

    const selectedPublisherTagIds =
      new Set(
        selectedPublisherTags
          .map(selectedPublisherTag => selectedPublisherTag.id)
      );

    return publisherTags
      .map(publisherTag => {
        return {
          data: publisherTag,
          id: String(publisherTag.id),
          label: publisherTag.name,
          selected: selectedPublisherTagIds.has(publisherTag.id),
        };
      });
  }

}
